import { InputFieldProps } from "./types";
import { FilterableSelect } from "../GenericInputComponents";

export const QuantityFunctionInput: React.FC<InputFieldProps> = ({ inputField, inputValue, onUpdate }) => {
	if (inputField.type !== "quantityFunction") {
		return <>non-quantity-function input field types is not currently supported</>;
	}

	const quantityValue = (inputValue ?? {}) as { functionType?: string; value?: string };

	const handleChange = (key: "functionType" | "value", value: string | undefined) => {
		const next = { ...quantityValue, [key]: value };
		const isEmpty = (next.functionType === undefined || next.functionType === "") && (next.value === undefined || next.value === "");
		onUpdate?.(isEmpty ? undefined : next);
	};

	return (
		<div className="flex flex-row items-center gap-2">
			<FilterableSelect
				options={inputField.options}
				onSelect={(value) => handleChange("functionType", value)}
				value={quantityValue.functionType}
				placeholder="select function"
			/>
			<input
				onChange={(e) => handleChange("value", e.target.value)}
				type="text"
				value={quantityValue.value ?? ""}
				placeholder="value"
				className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
			/>
		</div>
	);
};
